import React from 'react';
import PropTypes from 'prop-types';

const MamPaginator = ({ total, page, perPage, onPage }) => {
  const pages = Math.ceil(total / perPage);
  if (!total || pages <= 1) return null;

  const windowStart = Math.max(1, Math.min(page - 2, pages - 4));
  const windowPages = [];
  for (let p = windowStart; p <= Math.min(windowStart + 4, pages); p += 1) windowPages.push(p);

  const btn = 'font-americaMonoBold text-xs px-3 py-1 mx-2px rounded-full cursor-pointer';

  return (
    <div className="w-full flex flex-row items-center justify-between py-4">
      <span className="font-americaMonoRegular text-xs">{`${total} results · page ${page} of ${pages}`}</span>
      <div className="flex items-center">
        <button type="button" disabled={page <= 1} onClick={() => onPage(page - 1)} className={`${btn} text-black ${page <= 1 ? 'opacity-25' : ''}`}>‹</button>
        {windowPages.map(p => (
          <button key={p} type="button" onClick={() => onPage(p)} className={`${btn} ${p === page ? 'bg-black text-white' : 'text-black'}`}>{p}</button>
        ))}
        <button type="button" disabled={page >= pages} onClick={() => onPage(page + 1)} className={`${btn} text-black ${page >= pages ? 'opacity-25' : ''}`}>›</button>
      </div>
    </div>
  );
};

MamPaginator.propTypes = {
  total: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  onPage: PropTypes.func.isRequired,
};

export default MamPaginator;
